import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [authed, setAuthed] = useState(null); // null=checking, true, false

  useEffect(() => {
    const token = localStorage.getItem("lb_admin_token");
    if (!token) {
      setAuthed(false);
      return;
    }
    api
      .get("/admin/me")
      .then(() => setAuthed(true))
      .catch(() => {
        localStorage.removeItem("lb_admin_token");
        setAuthed(false);
      });
  }, []);

  const login = (token) => {
    localStorage.setItem("lb_admin_token", token);
    setAuthed(true);
  };
  const logout = () => {
    localStorage.removeItem("lb_admin_token");
    setAuthed(false);
  };

  return (
    <AuthContext.Provider value={{ authed, login, logout }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
